import React, { Component } from 'react'
import Modal from 'react-modal'
// import { connect } from 'react-redux'
import { Button, Grid, Row, Col } from 'react-bootstrap'
import { getModalStyles } from '../../common/utils'

class SelectedAviseringLockModal extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        const { eligibleAviseringLocks, selectedLock } = this.props

        return (
            <div>
                <Modal
                    ariaHideApp={false}
                    isOpen={true}
                    onRequestClose={() => this.props.closeModal()}
                    style={getModalStyles()}>

                    <div className="qCloseButton" onClick={() => this.props.closeModal()}>Stäng</div>

                    <Grid fluid>
                        <Row>
                            <Col lg={12} xs={12} style={{ textAlign: 'center' }}>
                                <h2>Välj aviseringsenhet</h2>
                            </Col>
                        </Row>

                        <br />

                        <Row>
                            {eligibleAviseringLocks.map((lock, i) => {
                                return (
                                    <Col key={i} lg={12} xs={12} style={{ textAlign: 'center' }} onClick={() => selectedLock(lock)}>
                                        <p style={{ marginTop: 12, color: '#006e78', backgroundColor: '', fontSize: 16 }} className="sub-title-text-container">
                                            Välj {lock.custom_name}
                                        </p>
                                    </Col>
                                )
                            })}
                        </Row>
                    </Grid>

                </Modal>
            </div >
        )
    }
}

export default SelectedAviseringLockModal